import React from "react"
import { Link } from "gatsby";

export default ({ children, onTogglSidebar }) => {

  return (
    <header className="cd-header">

      <img src={'../favicon-96x96.png'} height="42" className="pl-3 d-md-none"/>

      <ul className="cd-header-nav mr-3">
        <li className="cd-nav-item">
          {/*search*/}
        </li>
        <li className="cd-nav-item d-sm-down-none">
          <Link
            to="/introduction"
            className="cd-nav-link"
          >
            Getting Started
          </Link>
        </li>
        <li className="cd-nav-item d-sm-down-none">
          <Link
            to="/components/CAlert"
            className="cd-nav-link"
          >
            Components
          </Link>
        </li>
        <li className="cd-nav-item d-sm-down-none">
          <a
            href="https://github.com/coreui/coreui-react"
            className="cd-nav-link cd-signalize"
            target="_blank"
          >
            Github
          </a>
        </li>
        <li className="cd-nav-item">
          <a
            href="https://coreui.io/react"
            className="cd-btn-go-pro cd-btn-coreui"
            target="_blank"
          >
            Go pro
          </a>
        </li>
        <button className="cd-header-toggler cd-class-toggler" type="button" onClick={onTogglSidebar}></button>
      </ul>

    </header>
  )

}
